import React from 'react';
import { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import jwtDecode from 'jwt-decode';
import { BeatLoader } from 'react-spinners';

const ProtectedRoute = ({Component}) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();

    useEffect( () => {
        async function checkToken() {
            if(localStorage.getItem("token") !== 'null' || localStorage.getItem("token") !== null){
                //now check if token is valid for name/id
                const username = localStorage.getItem("username");
                const token = localStorage.getItem("token");

                if(!username || !token){
                    navigate('/login');
                }

                // ("about to check token for : " + username + " : " + token);
                await axios.post('https://dev.super-stream.co/api/checkToken', {
                    username,
                    token
                })
                .then(response =>  {
                    // console.log("test" + JSON.stringify(response));
                    // console.log(response.status);
                    if (response.status === 200) {
                        const tokenResponse = response.data;
                        // console.log(token);
                        // console.log(tokenResponse);
                        const user = jwtDecode(tokenResponse).user;
                        console.log("protectedroute");
                        console.log(user);
                        localStorage.setItem('token', tokenResponse.toString());
                        localStorage.setItem('username', user.username.toString());
                        localStorage.setItem('_id', user._id.toString());
                        localStorage.setItem('isSubscribed', user.isSubscribed);
                        setIsAuthenticated(true);
                        setIsLoading(false);
                    } else if (response.status === 201){
                        console.log('Invalid token, redirecting to login');
                        setIsAuthenticated(false);
                        setIsLoading(false);

                    }
                    else {
                    console.log('Error signing up');
                    }
                }).catch(error => {
                    console.error(error);
                    navigate('/login');
                });
            
                // navigate('/dashboard');
            }else{
                setIsAuthenticated(false);
                setIsLoading(false);
            }
        }
        checkToken();   
      }, []);

        // return (
        //     isAuthenticated ? <Component /> : <Navigate to="/login"  />
        // );

        if (isLoading) {
            return (
            <div className={`container-fluid`}>
                <div className={`row`} style={{height: '100vh'}}>
                    <div className={`col-md-4`}></div>
                    <div className={`col-md-4 justify-content-center d-flex flex-column flex-wrap align-content-center`}>
                        <BeatLoader color="#FFFFFF" />
                    </div>
                    <div className={`col-md-4`}></div>
                </div>
            </div>
        );}

        return (
            <>
              {isAuthenticated ? (
                <Component />
              ) : (
                <Navigate to="/login" replace={true} />
              )}
            </>
          );
};

export default ProtectedRoute;
